import { DayDate } from '@deltager/organizers/admin/core/date-format/dayDate';
import { setOptions, localeNo, localeEnGB } from '@mobiscroll/angular';

const retry = (numOfRetries: number, promiseFn: () => Promise<any>): Promise<any> =>
  promiseFn().catch((error) => (numOfRetries > 1 ? retry(numOfRetries - 1, promiseFn) : Promise.reject(error)));

const loadLocale = (locale: string): (() => Promise<any>) => {
  let currentLocale = locale;
  return () =>
    import(
      /* webpackInclude: /(en-GB|no|nb).mjs$/ */
      /* webpackExports: "default" */
      /* webpackPrefetch: true */
      /* webpackPreload: true */
      `node_modules/@angular/common/locales/${currentLocale}.mjs`
    ).catch((err) => {
      currentLocale = currentLocale.split('-')[0];
      throw Error(err);
    });
};

export function load(locale: string) {
  const loadLocalePromise = loadLocale(locale);

  // Day.js
  DayDate.setLocale(locale);

  // Mobiscroll
  setOptions({
    theme: 'ios',
    themeVariant: 'light',
    locale: locale == 'en-GB' ? localeEnGB : localeNo,
  });

  return retry(2, loadLocalePromise);
}
